import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object,
    setup: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { advisor } = this.props
    return {
      title: 't(New Template)',
      method: 'POST',
      action: `/api/admin/truevail/admin/advisors/${advisor.id}/templates`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Theme)', name: 'theme_id', type: 'dropdown', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/themes`, valueKey: 'id', textKey: 'title', required: true, selectFirst: true },
            { label: 't(Template)', name: 'template_id', type: 'dropdown', endpoint: '/api/admin/truevail/admin/templates', valueKey: 'id', textKey: 'title', required: true, selectFirst: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Container(null)(New)